/*--------------------------------------------------------------
    HERO VIDEO
--------------------------------------------------------------*/

(function (Drupal, once) {

  Drupal.behaviors.osjctHeroVideo = {

    attach: function (context) {

      const setHeroDimensions = (heroElement) => {
        const heroDimensions = heroElement.getBoundingClientRect();

        const heroWidthRequirement = ((heroDimensions.height / 9) * 16);
        const heroHeightRequirement = (((heroDimensions.width / 2) / 16) * 9);

        if (heroWidthRequirement > heroDimensions.width) {
          heroElement.style.setProperty('--osjct-hero-video-width', `${heroWidthRequirement}px`);
          heroElement.style.setProperty('--osjct-hero-video-height', `${heroDimensions.height}px`);
        } else {
          heroElement.style.setProperty('--osjct-hero-video-width', `${heroDimensions.width}px`);
          heroElement.style.setProperty('--osjct-hero-video-height', `${heroHeightRequirement}px`);
        }
      };

      const initVimeoPlayer = (heroElement, index) => {
        const videoIframe = heroElement.querySelector('.osjct-hero-video__video-embed-container iframe');
        const videoButton = heroElement.querySelector('.osjct-hero-video__video-embed-button');
        const videoButtonSpan = heroElement.querySelector('.osjct-hero-video__video-embed-button span');
        const videoButtonPausedModifierClass = 'osjct-hero-video__video-embed-button--paused';
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!videoIframe || !videoButton) return;

        // Assign a unique ID to the iframe for Vimeo SDK postMessage routing
        videoIframe.id = 'osjct-hero-video-player-' + index;

        // Initialize the Vimeo player
        const player = new Vimeo.Player(videoIframe);

        // After the player is ready, check if autoplay succeeded and force play if not
        player.ready().then(function () {
          if (prefersReducedMotion) {
            player.pause();
            videoButton.classList.add(videoButtonPausedModifierClass);
            videoButtonSpan.textContent = 'Play';
            return;
          }

          player.getPaused().then(function (paused) {
            if (paused) {
              player.play().catch(function (error) {
                console.error('Error autoplaying Vimeo video:', error);
              });
            }
          });
        });

        // Handle click event on the Pause/Play button
        videoButton.addEventListener('click', function () {
          player.getPaused().then(function (paused) {
            if (paused) {
              player.play();
              videoButton.classList.remove(videoButtonPausedModifierClass);
              videoButtonSpan.textContent = 'Pause';
            } else {
              player.pause();
              videoButton.classList.add(videoButtonPausedModifierClass);
              videoButtonSpan.textContent = 'Play';
            }
          }).catch(function (error) {
            console.error('Error getting Vimeo paused state:', error);
          });
        });
      };


      // Collect all hero video elements
      const heroElements = once('osjctHeroVideo', '.osjct-hero-video', context);

      // Init hero banner video
      heroElements.forEach(function (element, index) {


        // Init Vimeo player with autoplay and accessibility
        initVimeoPlayer(element, index);


        // Trigger setHeroDimensions on page load
        setHeroDimensions(element);


        // Add init class
        element.classList.add('osjct-hero-video--initialised');
      });
      

      // Add single resize event listener for all hero videos
      if (heroElements.length > 0) {
        once('osjctHeroVideoResize', 'body', context).forEach(function () {
          window.addEventListener('resize', () => {
            document.querySelectorAll('.osjct-hero-video.osjct-hero-video--initialised').forEach(function (heroElement) {
              
              setHeroDimensions(heroElement);
            });
          });
        });
      }
    }
  };

} (Drupal, once));
